import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import HitArea from '../HitArea';
const IconButton = /*#__PURE__*/forwardRef(({
  icon,
  color,
  size = 'small',
  align,
  iconProps,
  label,
  colorHover,
  disabled = false,
  onClick,
  ...props
}, ref) => {
  return /*#__PURE__*/React.createElement(HitArea, _extends({
    ref: ref,
    label: label,
    colorHover: colorHover,
    disabled: disabled,
    onClick: onClick
  }, props), /*#__PURE__*/React.createElement(Icon, _extends({
    icon,
    color,
    size,
    align
  }, iconProps)));
});
IconButton.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string,
  align: PropTypes.string,
  color: PropTypes.string,
  colorHover: PropTypes.string,
  disabled: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  iconProps: PropTypes.object,
  onClick: PropTypes.func,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export default IconButton;
//# sourceMappingURL=index.js.map